import Image from 'next/image'

export default function MarineIdentityIcon( { complete } ) {
  // const { bg, fg1, fg2 } = getIconColors( complete )
  
  return (
    <Image width={ 100 } height={ 100 } sizes="100vw" style={ { width: '100%', aspectRatio: '1' } } src={ complete ? '/images/icons/marine-identity-colour.png' : '/images/icons/marine-identity-grey.png' } alt="Marine identity icon" />  
  )
}
